import { User } from '../types/user';

export const isViewRecordsAllowed = (user: User | null) =>
  user && user.hasRecordsPermission;
